export const rules = {
  // 自动获取
  rparentId: [{ required: true, trigger: ["blur"], message: "请选择上级组织" }],
  cname: [{ required: true, trigger: ["blur"], message: "请输入商户名称" }],
};
